module.exports = __webpack_public_path__ + "img/index-pic2.87affa06.webp";